import TextLink from './component.styles'
export default TextLink



// WEBPACK FOOTER //
// ./src/components/TextLink/index.js